/* 🤖 this file was generated by svg-to-ts */
export const matIconAirplaneTicket: {
  name: 'airplane-ticket';
  data: string;
} = {
  name: 'airplane-ticket',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20.19 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.81-2-1.81-2zM20 18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v12zM8.87 15.66l-1.66-2.88.93-.25 1.26.99 2.39-.64-2.4-4.16 1.4-.38 4.01 3.74 2.44-.65a.967.967 0 0 1 1.18.68.988.988 0 0 1-.69 1.19l-8.86 2.36z"/></svg>`
};
